import { render, staticRenderFns } from "./InPendingMaterials.vue?vue&type=template&id=2124e17a&scoped=true"
import script from "./InPendingMaterials.vue?vue&type=script&lang=js"
export * from "./InPendingMaterials.vue?vue&type=script&lang=js"
import style0 from "./InPendingMaterials.vue?vue&type=style&index=0&id=2124e17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2124e17a",
  null
  
)

export default component.exports